<template>
  <div class="app-container">
    <!-- 搜索筛选区域 -->
    <div class="filter-container">
      <el-form :inline="true" :model="listQuery" class="filter-form">
        <el-form-item label="手机号账号ID">
          <el-input
            v-model="listQuery.phone_account_id"
            placeholder="请输入手机号账号ID"
            clearable
            size="small"
            style="width: 180px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="合作商">
          <el-select
            v-model="listQuery.app_client_id"
            placeholder="请选择合作商"
            clearable
            size="small"
            style="width: 180px"
            filterable
          >
            <el-option
              v-for="item in appClientList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="合作商订单号">
          <el-input
            v-model="listQuery.order_id"
            placeholder="请输入合作商订单号"
            clearable
            size="small"
            style="width: 160px"
          />
        </el-form-item>
        <el-form-item label="系统订单号">
          <el-input
            v-model="listQuery.system_order_no"
            placeholder="请输入系统订单号"
            clearable
            size="small"
            style="width: 160px"
          />
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            size="small"
            style="width: 240px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="handleFilter"
            >查询</el-button
          >
          <el-button size="small" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      border
      stripe
      size="small"
      element-loading-text="Loading"
      empty-text="暂无数据"
    >
      <el-table-column label="日志ID" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="合作商名称" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.app_client ? scope.row.app_client.name : '无' }}
        </template>
      </el-table-column>
      <el-table-column label="入住人姓名" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.guest_name || '无' }}
        </template>
      </el-table-column>
      <el-table-column label="原始手机号" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.original_phone }}
        </template>
      </el-table-column>
      <el-table-column label="替换手机号" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.phone_account ? scope.row.phone_account.phone : '无' }}
        </template>
      </el-table-column>
      <el-table-column label="合作商订单号" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_id || '无' }}
        </template>
      </el-table-column>
      <el-table-column label="系统订单号" min-width="180" align="center">
        <template slot-scope="scope">
          {{ scope.row.system_order_no || '无' }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'PhoneAccountUsageLog',
  data() {
    return {
      // 列表数据
      list: null,
      total: 0,
      listLoading: true,
      // 日期范围
      dateRange: null,
      // 查询参数
      listQuery: {
        page: 1,
        limit: 10,
        phone_account_id: undefined,
        app_client_id: undefined,
        order_id: undefined,
        system_order_no: undefined,
        start_at: undefined,
        end_at: undefined,
      },
      // 合作商列表（用于下拉选择）
      appClientList: [],
    }
  },
  created() {
    // 处理路由参数回填
    this.handleRouteQuery()
    // 初始化数据
    this.initData()
    // 加载列表
    this.getList()
  },
  methods: {
    /**
     * 处理路由参数回填筛选条件
     */
    handleRouteQuery() {
      const query = this.$route.query
      if (query.phone_account_id) {
        this.listQuery.phone_account_id = parseInt(query.phone_account_id)
      }
      if (query.app_client_id) {
        this.listQuery.app_client_id = parseInt(query.app_client_id)
      }
      if (query.order_id) {
        this.listQuery.order_id = query.order_id
      }
      if (query.system_order_no) {
        this.listQuery.system_order_no = query.system_order_no
      }
      if (query.start_at) {
        this.listQuery.start_at = query.start_at
      }
      if (query.end_at) {
        this.listQuery.end_at = query.end_at
      }
      // 恢复日期范围
      if (this.listQuery.start_at && this.listQuery.end_at) {
        this.dateRange = [this.listQuery.start_at, this.listQuery.end_at]
      }
    },

    /**
     * 初始化数据 - 加载下拉选项
     */
    initData() {
      this.getAppClientList()
    },

    /**
     * 获取合作商列表（用于下拉选择）
     */
    getAppClientList() {
      request({
        url: '/api/backend/app-client/list',
        method: 'get',
        params: { limit: 500 },
      })
        .then((response) => {
          this.appClientList = response.data.data || []
        })
        .catch((error) => {
          console.error('获取合作商列表失败:', error)
        })
    },

    /**
     * 获取列表数据
     */
    getList() {
      this.listLoading = true

      request({
        url: '/api/backend/phone-account-pool/usage-logs',
        method: 'get',
        params: this.listQuery,
      })
        .then((response) => {
          this.list = response.data.data || []
          this.total = response.data.total || 0
        })
        .catch((error) => {
          console.error('获取列表失败:', error)
          this.$message.error('获取列表失败')
        })
        .finally(() => {
          this.listLoading = false
        })
    },

    /**
     * 搜索查询
     */
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },

    /**
     * 重置筛选条件
     */
    handleReset() {
      this.listQuery = {
        page: 1,
        limit: 10,
        phone_account_id: undefined,
        app_client_id: undefined,
        order_id: undefined,
        system_order_no: undefined,
        start_at: undefined,
        end_at: undefined,
      }
      this.dateRange = null
      this.getList()
    },

    /**
     * 页大小变化
     */
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.listQuery.page = 1
      this.getList()
    },

    /**
     * 页码变化
     */
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
  },
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
.filter-form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>
